jQuery(document).ready(function ($) {
  function checkAnnouncementBar() {
    let htmlStyle = $("html").attr("style");

    if (htmlStyle && htmlStyle.includes("--announcement-bar-height: 0px;")) {
      $(window).on("scroll", function () {
        if ($(window).scrollTop() > 1) {
          $("body").addClass("scrolling");
        } else {
          $("body").removeClass("scrolling");
        }
      });
    } else {
      $("body").removeClass("scrolling");
    }
  }

  checkAnnouncementBar();
});




